import { Route, Routes } from 'react-router-dom';
import {
    CREATE_ORG_PATH,
    DASHBOARD_PATH,
    DEVICES_PATH,
    LOGIN_PATH,
    SETTINGS_PATH,
    USERS_PATH,
    MOBILE_HOME_PATH,
    DEVICE_LOGIN_PATH,
    ACTIVITY_LOG_PATH,
    USER_RESTRICTED_PERMISSION_PATH,
} from './RouteConstants';
import Devices from '../components/Devices/Devices';
import User from '../components/User/User';
import ErrorPageNotFound from '../pages/ErrorPageNotFound/ErrorPageNotFound';
import Login from '../pages/Login/Login';
import PageLayout from '../pages/Content/Content';
import PrivateRoute from './ProtectedRoutes/PrivateRoute';
import CreateOrganization from '../pages/CreateOrganization/CreateOrganization';
import Settings from '../pages/Settings/Settings';
import Dashboard from '../components/Dashboard/Dashboard';
import MobileHome from '../pages/mobile/MobileHome/MobileHome';
import DeviceLogin from '../pages/mobile/Login/DeviceLogin';
import UserRestrictedPermission from '../pages/UserRestrictedPermissionPage/UserRestrictedPermission';
import ActivityLogs from '../components/ActivityLogs/ActivityLogs';

const RoutePaths = () => {
    return (
        <Routes>
            <Route path={LOGIN_PATH} element={<Login />} />
            <Route path={DEVICE_LOGIN_PATH} element={<DeviceLogin />} />
            <Route path={MOBILE_HOME_PATH} element={<MobileHome />} />
            <Route
                path={USER_RESTRICTED_PERMISSION_PATH}
                element={<UserRestrictedPermission />}
            />
            <Route element={<PrivateRoute />}>
                <Route path={CREATE_ORG_PATH} element={<CreateOrganization />} />
                <Route element={<PageLayout />}>
                    <Route path={DASHBOARD_PATH} element={<Dashboard />} />
                    <Route path={DEVICES_PATH} element={<Devices />} />
                    <Route path={USERS_PATH} element={<User />} />
                    <Route path={ACTIVITY_LOG_PATH} element={<ActivityLogs/>} />
                    <Route path={SETTINGS_PATH} element={<Settings />} />
                </Route>
                <Route path='*' element={<ErrorPageNotFound />} />
            </Route>
        </Routes>
    );
};

export default RoutePaths;
